(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oumish-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!window.OumishRitualAssetsLoaded) {
    window.OumishRitualAssetsLoaded = true;

    const updateFilterNavigation = (track) => {
      const carousel = track.closest('[data-oumish-filter-carousel]');
      if (!carousel) return;

      const previousButton = carousel.querySelector('[data-oumish-filter-nav="previous"]');
      const nextButton = carousel.querySelector('[data-oumish-filter-nav="next"]');
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      if (previousButton) previousButton.disabled = track.scrollLeft <= 2;
      if (nextButton) nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
    };

    const updateAllFilterNavigation = () => {
      document.querySelectorAll('[data-oumish-filter-track]').forEach(updateFilterNavigation);
    };

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target.matches?.('[data-oumish-filter-track]')) {
          updateFilterNavigation(event.target);
        }
      },
      true
    );

    window.addEventListener('resize', updateAllFilterNavigation);
    document.addEventListener('shopify:section:load', updateAllFilterNavigation);
    requestAnimationFrame(updateAllFilterNavigation);

    document.addEventListener('click', async (event) => {
      const filterNavigationButton = event.target.closest('[data-oumish-filter-nav]');

      if (filterNavigationButton) {
        const carousel = filterNavigationButton.closest('[data-oumish-filter-carousel]');
        const track = carousel?.querySelector('[data-oumish-filter-track]');
        if (!track) return;

        const direction = filterNavigationButton.dataset.oumishFilterNav === 'next' ? 1 : -1;
        const distance = Math.max(96, Math.round(track.clientWidth * 0.72));
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        window.setTimeout(() => updateFilterNavigation(track), 280);
        return;
      }
      const filterButton = event.target.closest('[data-oumish-filter]');

      if (filterButton) {
        const ritual = filterButton.closest('[data-oumish-ritual]');
        const selectedCategory = filterButton.dataset.oumishFilter;

        ritual.querySelectorAll('[data-oumish-filter]').forEach((button) => {
          const active = button === filterButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        ritual.querySelectorAll('[data-oumish-category]').forEach((card) => {
          card.hidden = selectedCategory !== 'all' && card.dataset.oumishCategory !== selectedCategory;
        });

        ritual.querySelector('.oumish-ritual__products')?.scrollTo({ left: 0, behavior: 'smooth' });
        filterButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        updateFilterNavigation(filterButton.closest('[data-oumish-filter-track]'));
        return;
      }

      const addButton = event.target.closest('[data-oumish-add]');
      if (!addButton || addButton.disabled) return;

      const ritual = addButton.closest('[data-oumish-ritual]');
      const errorElement = ritual.querySelector('.oumish-ritual__error');
      const labelElement = addButton.querySelector('[data-oumish-add-label]');
      const originalLabel = labelElement?.textContent || addButton.textContent;
      const root = window.Shopify?.routes?.root || '/';

      addButton.disabled = true;
      addButton.classList.add('is-loading');
      if (labelElement) {
        labelElement.textContent = addButton.dataset.addingLabel;
      }
      errorElement.hidden = true;

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(addButton.dataset.oumishAdd), quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || addButton.dataset.errorMessage);
        }

        const drawer = document.querySelector('cart-drawer');
        if (drawer && result.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(result);
        } else {
          window.location.assign(`${root}cart`);
        }
      } catch (error) {
        errorElement.textContent = error.message || addButton.dataset.errorMessage;
        errorElement.hidden = false;
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
        if (labelElement) {
          labelElement.textContent = originalLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
